import React from 'react';

var MenuIcon = function MenuIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "menu"), /*#__PURE__*/React.createElement("g", {
    id: "\u7EC8\u7A3F\u6807\u6CE8\u6587\u4EF6",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u79FB\u52A8\u7AEF-\u9ED8\u8BA4\u72B6\u6001",
    transform: "translate(-291, -112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u5BFC\u822A",
    transform: "translate(8, 100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "more\u5907\u4EFD",
    transform: "translate(283, 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,4 L19.5,4 C19.7761424,4 20,4.22385763 20,4.5 L20,5.5 C20,5.77614237 19.7761424,6 19.5,6 L4.5,6 C4.22385763,6 4,5.77614237 4,5.5 L4,4.5 C4,4.22385763 4.22385763,4 4.5,4 Z M4.5,11 L19.5,11 C19.7761424,11 20,11.2238576 20,11.5 L20,12.5 C20,12.7761424 19.7761424,13 19.5,13 L4.5,13 C4.22385763,13 4,12.7761424 4,12.5 L4,11.5 C4,11.2238576 4.22385763,11 4.5,11 Z M4.5,18 L19.5,18 C19.7761424,18 20,18.2238576 20,18.5 L20,19.5 C20,19.7761424 19.7761424,20 19.5,20 L4.5,20 C4.22385763,20 4,19.7761424 4,19.5 L4,18.5 C4,18.2238576 4.22385763,18 4.5,18 Z",
    id: "\u5F62\u72B6\u7ED3\u5408",
    fill: "#091221"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62",
    fill: "#D8D8D8",
    opacity: "0",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }))))));
};

export { MenuIcon as default };
